export var ACTION;
(function (ACTION) {
    ACTION["CHANGE_TAB"] = "CHANGE_TAB";
    ACTION["ON_SEARCH_LEADS"] = "ON_SEARCH_LEADS";
    ACTION["ON_SELECT"] = "ON_SELECT";
    ACTION["ON_SORT"] = "ON_SORT";
    ACTION["ON_SELECT_ALL_LEADS"] = "ON_SELECT_ALL_LEADS";
    ACTION["ON_LOAD"] = "ON_LOAD";
    ACTION["CHANGE_INPUT_AC"] = "CHANGE_INPUT_AC";
    ACTION["ON_SEARCH_AC"] = "ON_SEARCH_AC";
    ACTION["ON_SELECT_AC"] = "ON_SELECT_AC";
    ACTION["ON_SORT_AC"] = "ON_SORT_AC";
    ACTION["ON_SELECT_ALL_AC"] = "ON_SELECT_ALL_AC";
    ACTION["ON_FILTER_LEADS_BY_STATUS"] = "ON_FILTER_LEADS_BY_STATUS";
    ACTION["ON_LOAD_MORE_DATA"] = "ON_LOAD_MORE_DATA";
    ACTION["ON_LEFT_PAGINATION"] = "ON_LEFT_PAGINATION";
    ACTION["ON_RIGHT_PAGINATION"] = "ON_RIGHT_PAGINATION";
    ACTION["ON_TRACK_CUSTOMER_JOURNEY"] = "ON_TRACK_CUSTOMER_JOURNEY";
    ACTION["ON_REGISTER_LEADS"] = "ON_REGISTER_LEADS";
    ACTION["GO_TO_HOME"] = "GO_TO_HOME";
    ACTION["GO_TO_FAQ"] = "GO_TO_FAQ";
    ACTION["GO_TO_WHATSAPP"] = "GO_TO_WHATSAPP";
    ACTION["GO_TO_CALL"] = "GO_TO_CALL";
    ACTION["LOGOUT"] = "LOGOUT";
    ACTION["OPEN_MENU"] = "OPEN_MENU";
    ACTION["VIEW_DETAILS"] = "VIEW_DETAILS";
    ACTION["SHARE_LINK"] = "SHARE_LINK";
    ACTION["SHARE_LINK_REF"] = "SHARE_LINK_REF";
    ACTION["CHECK_LIMIT_VIEW_DETAILS"] = "CHECK_LIMIT_VIEW_DETAILS";
    ACTION["ON_CLICK_FILTER"] = "ON_CLICK_FILTER";
    ACTION["HANDLE_CONNECTION"] = "HANDLE_CONNECTION";
    ACTION["PENDING_REGISTRATION"] = "PENDING_REGISTRATION";
    ACTION["COMPLETE_REGISTRATION"] = "COMPLETE_REGISTRATION";
    ACTION["PENDING_CUSTOMER"] = "PENDING_CUSTOMER";
    ACTION["PENDING_REGISTRATION_NRML"] = "PENDING_REGISTRATION_NRML";
    ACTION["PENDING_CUSTOMER_NRML"] = "PENDING_CUSTOMER_NRML";
    ACTION["COMPLETE_REGISTRATION_NRML"] = "COMPLETE_REGISTRATION_NRML";
    ACTION["ON_TRACK_PENDING_CUSTOMER_JOURNEY"] = "ON_TRACK_PENDING_CUSTOMER_JOURNEY";
    ACTION["SHARE_PENDING_CUSTOMER_LINK"] = "SHARE_PENDING_CUSTOMER_LINK";
    ACTION["VIEW_PENDING_CUSTOMER_DETAILS"] = "VIEW_PENDING_CUSTOMER_DETAILS";
    ACTION["CLEAR_SEARCH_TEXT"] = "CLEAR_SEARCH_TEXT";
    ACTION["REMOVE_LOCAL_DATA"] = "REMOVE_LOCAL_DATA";
})(ACTION || (ACTION = {}));
